import { createFileRoute, Outlet } from '@tanstack/react-router';

/**
 * Layout route for /kontrollgaenge. List in kontrollgaenge.index.tsx,
 * detail in kontrollgaenge.$id.tsx, start-form in kontrollgaenge.neu.tsx.
 */
export const Route = createFileRoute('/kontrollgaenge')({
  component: KontrollgaengeLayout,
});

function KontrollgaengeLayout(): JSX.Element {
  return <Outlet />;
}
